import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to track sorting direction
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Custom data filter for summing column
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    var size = $$('datatable').getPager().config.size; // Current page size
                    var page = $$('datatable').getPage(); // Current page number
                    var first = size * page; // First item index on the current page
                    var last = first + size - 1; // Last item index on the current page
                    var count = 0; // Counter for items processed
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Summing values within the current page
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Formatting the result
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Returning the layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {},
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 420 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.datatable(obj, common) + obj.value // Display group value
                                            );
                                        return obj.Date; // Display date value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            return ''; // No details for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Ticket Id'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'BetShop', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'DatePayment', // Column ID
                                    header: _('Fecha de pago'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'BetShopPayment', // Column ID
                                    header: _('Punto Venta Pagó'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Cashier', // Column ID
                                    header: _('Cajero'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('Usuario Id'), // Column header with localization
                                    width: 80, // Column width
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Usuario'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 80, // Column width
                                    options: [
                                        // Dropdown options for state
                                        { id: 'C', value: _('Abierto') },
                                        { id: 'S', value: _('Ganó') },
                                        { id: 'N', value: _('Perdió') },
                                        { id: 'A', value: _('No Acción') },
                                        { id: 'R', value: _('Pendiente') },
                                        { id: 'W', value: _('En Espera') },
                                        { id: 'J', value: _('Rechazada') },
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'),
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'),
                                        },
                                    ],
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'mySummColumn' }, // Footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'mySummColumn' }, // Footer content
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'mySummColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmountTotal', // Column ID
                                    header: _('Premio Total'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'mySummColumn' }, // Footer content
                                },
                                { id: 'Odds', header: _('Odds'), width: 100 }, // Odds column
                                { id: 'UserIP', header: 'IP', width: 150 }, // User IP column
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger event with user ID
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'null/Report/GetBetHistory',
                        },
                        {
                            view: 'treetable', // Tree table view
                            id: 'datatable2', // Unique ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {},
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 420 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Display group value
                                            );
                                        return obj.Date; // Display date value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            return ''; // No details for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon
                                        }
                                    },
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Usuario'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger event with user ID
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA2', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'null/Report/GetBetHistory',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main grid object.
     */
    init(grid) {
        var gridppal = $$('datatable'); // Main datatable reference
        var grid2 = $$('datatable2'); // Secondary datatable reference
        $$('toolbar2').hide(); // Hide secondary toolbar
        grid2.hide(); // Hide secondary datatable
        var url = gridppal.data.url; // Data source URL
        var filter = ''; // Filter string
        const _ = this.app.getService('locale')._; // Localization service
        var flag = false; // Flag for export operations

        // Event handler for after loading data in the secondary grid
        grid2.attachEvent('onAfterLoad', function () {
            $$('datatable2').data.group({
                // Grouping data by UserName
                by: 'UserName',
                map: {
                    Date: ['UserName'],
                    Amount: ['Amount', 'sum'],
                    WinningAmount: ['WinningAmount', 'sum'],
                    Tax: ['Tax', 'sum'],
                },
            });
        });

        // Event handler for filtering data based on user input
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            var string2 = ''; // Query string for sorting
            var providergroup = 0; // Provider group flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Sort') {
                    // Check for sorting
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by Date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[UserId]='; // Sort by UserId
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sort by Amount
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir') {
                    // Check for direction
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (object[i][0] == 'IsDetails') {
                    // Check for details flag
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'DateStart') {
                        // Date range start
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] == 'DateEnd') {
                            // Date range end
                            var date = object[i][1].split(' - '); // Split date range
                            console.log(date);
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            if (
                                object[i][0] != 'Sort' &&
                                object[i][0] != 'Dir' // Exclude sort and direction
                            ) {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                // Check if provider group is not set
                gridppal.show(); // Show main grid
                grid2.hide(); // Hide secondary grid
                gridppal.clearAll(); // Clear main grid data
                gridppal.load(
                    url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2, // Load data with filters
                );
                $$('toolbar').show(); // Show main toolbar
                $$('toolbar2').hide(); // Hide secondary toolbar
            } else {
                grid2.show(); // Show secondary grid
                gridppal.hide(); // Hide main grid
                grid2.clearAll(); // Clear secondary grid data
                grid2.load(
                    url + '?start=0&count=' + grid2.data.$pagesize + string1 + string2, // Load data with filters
                );
                grid2.adjust(); // Adjust secondary grid layout
                $$('toolbar2').show(); // Show secondary toolbar
                $$('toolbar').hide(); // Hide main toolbar
            }
            filter = string1 + string2; // Update filter string
        });

        // Event handler for after sorting the main grid
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click in the main grid
        gridppal.attachEvent('onItemClick', function (id, e, node) {});

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            gridppal.load(
                gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });

        // Event handler for export filter
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst; // Variable for first item index
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index
            } else {
                firstfirst = filterData.first; // Keep first index
            }
            gridppal.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            gridppal.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        // Check if export flag is set
                        var size = gridppal.getPager().config.size; // Get page size
                        var page = gridppal.getPage(); // Get current page
                        var first = size * page; // Calculate first item index
                        var last = first + size - 1; // Calculate last item index
                        if ($$('Export').getValue() == '1') {
                            // Check export type
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Apuestas') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        gridppal.getIndexById(obj.id) >= first && gridppal.getIndexById(obj.id) <= last // Filter for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Apuestas'), // Filename for export
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                // Check for PDF export
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Apuestas') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF(gridppal, {
                                    filter: function (obj) {
                                        return (
                                            gridppal.getIndexById(obj.id) >= first &&
                                            gridppal.getIndexById(obj.id) <= last // Filter for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Apuestas'), // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context for event handler
            );
        });

        // Event handler for export filter on secondary grid
        this.on(this.app, 'export2:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst; // Variable for first item index
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index
            } else {
                firstfirst = filterData.first; // Keep first index
            }
            grid2.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            grid2.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        // Check if export flag is set
                        var size = grid2.getPager().config.size; // Get page size
                        var page = grid2.getPage(); // Get current page
                        var first = size * page; // Calculate first item index
                        var last = first + size - 1; // Calculate last item index
                        if ($$('Export2').getValue() == '1') {
                            // Check export type
                            for (var j = 0; j < grid2.config.columns.length; j++) {
                                if (grid2.config.columns[j].exportType) {
                                    delete grid2.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Apuestas') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(grid2, {
                                filter: function (obj) {
                                    return (
                                        grid2.getIndexById(obj.id) >= first && grid2.getIndexById(obj.id) <= last // Filter for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Apuestas'), // Filename for export
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export2').getValue() == '2') {
                                // Check for PDF export
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Apuestas') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF(grid2, {
                                    filter: function (obj) {
                                        return (
                                            grid2.getIndexById(obj.id) >= first && grid2.getIndexById(obj.id) <= last // Filter for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Apuestas'), // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export2').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context for event handler
            );
        });
    }
}

// FILE DOCUMENTED
